module.exports = __webpack_public_path__ + "img/timeLine-four-hover.eb93a6c4.png";